var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyChild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1844_2248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.299805,
    width: 20.3598,
    height: 20.3598,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1844_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35233 4.48637C5.88538 4.48637 5.48565 4.32059 5.15313 3.98904C4.82061 3.6575 4.65434 3.25893 4.65434 2.79335C4.65434 2.32778 4.82061 1.92921 5.15313 1.59766C5.48565 1.26612 5.88538 1.10034 6.35233 1.10034C6.81927 1.10034 7.219 1.26612 7.55152 1.59766C7.88405 1.92921 8.05031 2.32778 8.05031 2.79335C8.05031 3.25893 7.88405 3.6575 7.55152 3.98904C7.219 4.32059 6.81927 4.48637 6.35233 4.48637ZM15.2667 8.7189C14.913 8.7189 14.6123 8.59545 14.3647 8.34855C14.1171 8.10165 13.9932 7.80185 13.9932 7.44914C13.9932 7.09643 14.1171 6.79662 14.3647 6.54972C14.6123 6.30283 14.913 6.17938 15.2667 6.17938C15.6205 6.17938 15.9212 6.30283 16.1688 6.54972C16.4164 6.79662 16.5402 7.09643 16.5402 7.44914C16.5402 7.80185 16.4164 8.10165 16.1688 8.34855C15.9212 8.59545 15.6205 8.7189 15.2667 8.7189ZM4.65434 18.0305V12.1049H3.38086V7.02588C3.38086 6.56031 3.54712 6.16174 3.87964 5.83019C4.21216 5.49865 4.6119 5.33287 5.07884 5.33287H7.62581C7.93711 5.33287 8.2201 5.40694 8.4748 5.55508C8.7295 5.70322 8.93467 5.91132 9.09032 6.17938L12.1255 11.4066L12.9957 10.1156C13.1089 9.94633 13.261 9.8123 13.452 9.71354C13.643 9.61478 13.8447 9.5654 14.0569 9.5654H16.5402C16.894 9.5654 17.1946 9.68885 17.4423 9.93575C17.6899 10.1826 17.8137 10.4824 17.8137 10.8352V13.7979H16.9647V18.0305H13.5687V12.0203L12.9108 12.9514H11.043L8.8993 9.2268V18.0305H4.65434Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyChild);
export default __webpack_public_path__ + "static/media/greyChild.737505c2a1aac0fead891a01284ae2f4.svg";
export { ForwardRef as ReactComponent };